import { Box } from '@chakra-ui/react';

const SortableWrapper = ({ children }) => {
  return (
    <Box width="100%" height="100%" display="flex" justifyContent="center">
      <Box width="100%" maxWidth="1400px">
        {children}
      </Box>
    </Box>
  );
};

export default SortableWrapper;
